Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.DateRangeBuilder
  constructor: (session) ->
    @session = session

  build: (timeInSeconds) ->
    millisecondsInADay = 24 * 3600 * 1000
    return JSON.parse(@session.attributes.composite_filter_json)['date'] unless timeInSeconds
    {
      type: 'date_range',
      start_time: moment(new Date(timeInSeconds * 1000)).format('YYYY-MM-DDTHH:mm:ssZ'),
      end_time: moment(new Date(timeInSeconds * 1000 + millisecondsInADay)).format('YYYY-MM-DDTHH:mm:ssZ')
    }
